// src/components/Portfolio.tsx
import React, { useState, useEffect } from "react";
import { Button } from "./Button";
import { ProjectCard } from "./ProjectCard";
import { projects } from "../data/projects";

interface PortfolioProps {
  onBack: () => void;
}

export const Portfolio: React.FC<PortfolioProps> = ({ onBack }) => {
  const [messageVisible, setMessageVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMessageVisible(false);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="relative flex flex-col w-full h-screen bg-gradient-to-b from-teal-100 via-teal-50 to-white"
      style={{ paddingBottom: "80px" }}
    >
      {messageVisible && (
        <div className="hidden sm:flex items-center justify-center bg-yellow-400 text-yellow-800 rounded-md w-[370px] px-3 py-2 text-xs font-semibold absolute top-2 right-2 shadow-md select-none z-10">
          Por razones de confidencialidad, no puedo mostrar los proyectos en
          funcionamiento, pero con gusto puedo contarte más sobre ellos.
        </div>
      )}

      <div className="sticky top-0 z-5 py-4 md:py-5 bg-teal-700 shadow-md">
        <h2 className="text-3xl md:text-4xl font-medium md:font-semibold text-center text-white text-shadow tracking-wide">
          Portafolio
        </h2>
      </div>

      <div className="flex flex-col gap-8 overflow-x-hidden overflow-y-auto px-8 pb-8 mt-8 w-full max-w-5xl mx-auto flex-1 md:scrollbar-custom">
        {projects.map((project, index) => (
          <ProjectCard
            idx={index}
            title={project.title}
            description={project.description}
            image={project.image}
            techs={project.techs}
            link={project.link}
          />
        ))}
      </div>

      <div className="fixed bottom-4 w-full flex justify-center z-5">
        <Button onClick={onBack}>Volver</Button>
      </div>
    </div>
  );
};
